import React, { useState, useRef, useEffect } from "react";
import {
    Image as ImageIcon, X, Globe, ExternalLink
} from "lucide-react";
export default function ToggleSetting({ label, tooltip, value, onChange }) {
    return (
        <label className="flex items-center gap-2 cursor-pointer">
            <input
                type="checkbox"
                checked={value}
                onChange={(e) => onChange(e.target.checked)}
                className="accent-[#4267B2] cursor-pointer"
                title={tooltip}
            />
            <span title={tooltip} className="cursor-pointer">{label}</span>
        </label>
    );
}